<template>
  <!-- History -->
  <div v-if="isShowHistory">

    <table-element
      :isShowFilter="false"
      :title="title"
      :fields="fieldsObj"
      :arrOfElement="returnHistory"
      :sortSpacing="0"
      :isShowSelectAll="false"
      :sortable="false"
      class="card mt-2"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
        <p v-if="!history" key="no_history" class="text-center m-2">{{$t('HistoryPage.no_history_found')}}</p>
        <span v-if="isShowDescription" class="mx-2"><p>{{$t('DistributedHistory.alert_description')}}</p></span>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(entry, index) in content.results" :key="index" class="table-element_hover text-center">
          <td>{{getHistoryKey(index, content.results.length)}}
            <hover-tool-tip
              v-for="(comments, index) in entry.historyComment" :key="index"
              :text="`${formatDate(comments.timestamp)} ${comments.message}`"
              :top="true"
              :right="true"
              :clickable="false"
            />
          </td>
          <td>{{entry.chauffeurName || '-'}}</td>
          <td>{{entry.dateDispatch || '-'}}</td>
          <td>
            <span class="nowrap">{{ shortenString($realName(entry, 'transmitter')) || '-'}}
              <hover-tool-tip
                :text="`<div>${entry.transmitterAddress || '-'} ${entry.transmitterCity || '-'}
                          <br>${entry.transmitterProvince || '-'} ${entry.transmitterPostcode || '-'}, ${entry.transmitterCountry || '-'}
                        </div>`"
                :left="true"
                :top="true"
                clickable
              />
            </span>
          </td>
          <td>
            <span class="nowrap">{{ shortenString($realName(entry, 'receiver')) || '-'}}
              <hover-tool-tip
                :text="`<p>${entry.receiverAddress || '-'} ${entry.receiverCity || '-'}
                          <br>${entry.receiverProvince || '-'} ${entry.receiverPostcode || '-'}, ${entry.receiverCountry || '-'}
                        </p>`"
                :left="true"
                :top="true"
                clickable
              />
            </span>
          </td>
          <td v-if="entry.pickDate">{{ getDate(entry.pickDate)}}</td> <td v-else>-</td>
          <td v-if="entry.dropDate">{{ getDate(entry.dropDate)}}</td> <td v-else>-</td>
          <td>{{ entry.numRef || '-'}}</td>
          <td v-if="hasEntryPrice(entry)">{{ formatEntryPrice(entry) }}</td> <td v-else>-</td>
          <td>
            <input type="button" class="btn btn-kne-orange pull-right" @click="openModificationDelivery(entry, getHistoryKey(index, content.results.length))" :value="$t('OrderInfo.delivery.modify')">
          </td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-for="(entry, historyKey) in content.results" :key="historyKey + 1" class="card my-3 mx-2">
          <div class="card-header">
            <h4>{{ orderId || '-'}}
              <hover-tool-tip
                v-for="(comments, index) in entry.historyComment" :key="index"
                :text="`${formatDate(comments.timestamp)} ${comments.message}`"
                :top="true"
                :right="true"
                :clickable="false"
              />
            </h4>
          </div>
          <p class="m-1">{{ entry.chauffeurName || '-' }}</p>
          <p class="m-1">{{ entry.dateDispatch || '-' }}</p>
          <p class="m-1">{{ entry.dateTransmitterName || '-' }}</p>
          <p class="m-1">{{ $realName(entry, 'receiver') || '-' }}</p>
          <p class="m-1" v-if="entry.pickDate">{{ getDate(entry.pickDate)}}</p> <p class="m-1" v-else>-</p>
          <p class="m-1" v-if="entry.dropDate">{{ getDate(entry.dropDate)}}</p> <p class="m-1" v-else>-</p>
          <p class="m-1" v-if="entry.numRef">{{ entry.numRef }}</p> <p class="m-1" v-else>-</p>
          <p class="m-1" v-if="hasEntryPrice(entry)">{{ formatEntryPrice(entry) }}</p> <p class="m-1" v-else>-</p>
          <div class="m-2" id="action">
            <input type="button" class="btn btn-kne-orange pull-right" @click="openModificationDelivery(entry, getHistoryKey(index, content.results.length))" :value="$t('OrderInfo.delivery.modify')">
          </div>
        </div>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

    <modification-delivery-modal
      v-if="isModificationDeliveryModal"
      ref="modifDeliveryModal"
      :isOpen="isModificationDeliveryModal"
      :orderId="orderId"
      :entry="entryData"
      :historyKey="entryHistoryKey"
      :priceOrderLink="priceOrderLink"
      @closeModal="isModificationDeliveryModal = false"
      @onOrderModification="onOrderModification"
    />

  </div>
</template>

<script>
import ModificationDeliveryModal from '../Modal-templates/ModificationDelivery-modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
/** @@@@@@@@@@@@
 * This component seems to be problematic, especially noticeable in OrderInfo with a Transfered order where the component will not properly load.
 * However, an exact copy of this component called @name TransferHistory will properly display information
 * I don't know why and I can't figure out why.
 */
export default {
  name: 'HistoryPage',
  components: {
    ModificationDeliveryModal,
    TableElement,
    hoverToolTip
  },

  data () {
    return {
      isModificationDeliveryModal: false,
      entryData: {},
      entryHistoryKey: '',
      objToArray: [],
      fieldsObj: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderId',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.driver'),
         type: 'driverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.date'),
         type: 'dateDispatch',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.pickup'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.delivery'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('HistoryPage.pickTime'),
         type: 'pickDate',
         value: ''
       },
       {
         text: this.$t('HistoryPage.dropTime'),
         type: 'dropDate',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.price'),
         type: 'price',
         value: ''
       },
       {
         text: '',
         type: '',
         value: ''
       }
      ]
    }
  },

  props: {
    title: {
      type: String,
      required: true
    },

    // TODO (OrderInfo-Transfer-drop-history/Render): Render problem in OrderInfo, the data loads into the prop properly but the table
    // doesn't update to show the data inside, so I need to manually click a button to toggle on/off to update it
    isShowHistory: {
      type: Boolean,
      required: false,
      default: true
    },

    history: {
      type: [Array, Object, String],
      required: true
    },

    order: {
      type: Object,
      required: true
    },

    orderId: {
      type: String,
      required: true
    },

    priceOrderLink: {
      type: Array,
      required: true
    },

    preBodyText: {
      type: String,
      required: false,
      default: ''
    },

    isShowDescription: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  created () {
    if (this.isObject(this.history)) this.returnHistory
    this.isLoading = false
  },

  methods: {
    // (OrderInfo-Transfer-drop-history/Render)
    forceUpdate () {
      this.isShowHistory = !this.isShowHistory
    },

    onOrderModification (order) {
      this.history[this.entryHistoryKey].price = order.price
      this.history[this.entryHistoryKey].prix = order.price
      this.history[this.entryHistoryKey].numRef = order.numRef
      this.history[this.entryHistoryKey].comment = order.comment
      this.$emit('onOrderModification')
    },

    hasValue (value) {
      return value !== undefined && value !== null && value !== ''
    },

    hasEntryPrice (entry) {
      if (!entry || typeof entry !== 'object') return false
      return this.hasValue(entry.price) || this.hasValue(entry.prix)
    },

    getEntryPrice (entry) {
      if (!entry || typeof entry !== 'object') return 0
      if (this.hasValue(entry.price)) return Number(entry.price) || 0
      if (this.hasValue(entry.prix)) return Number(entry.prix) || 0
      return 0
    },

    formatEntryPrice (entry) {
      return this.getEntryPrice(entry).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' })
    },

    openModificationDelivery (entry, historyKey) {
      this.entryData = entry
      this.entryHistoryKey = `${historyKey}`

      this.isModificationDeliveryModal = true
    },

    formatDate (date) {
      var fdate = new Date(date)
      return fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)
    },

    isObject (obj) {
      let isObject = obj === Object(obj)
      let isArray = Object.prototype.toString.call(obj) !== '[object Array]'

      if (isObject && isArray) return true
      else return false
    },

    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    convertToArray (history) {
      let array = []

      for (const key in history) {
        if (Object.hasOwnProperty.call(history, key)) {
          array.push(history[key])
        }
      }

      return array
    },

    getHistoryKey (index, arrLength) {
      let keys = Object.keys(this.history)
      return keys[arrLength - (index + 1)]
    },

    /** Convert a timestamp value to a Date + Time string (The timestamp that it takes in is kinda scuffed) */
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    shortenString (text) {
      if (typeof text === 'undefined') return text
      else {
        let subString = text.substring(0, 22)
        if (text.length > 22) subString += '...'
        return subString
      }
    }
  },
  computed: {
    returnHistory () {
      this.objToArray = this.convertToArray(this.history)
      return this.objToArray
    }
  }
}
</script>

<style scoped>
</style>
